var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003C!-- 新規作成--\u003E\u003Cmd-button ng-click=\"showCategoryModal()\"\u003E\u003Ci class=\"mdi mdi-settings\"\u003E\u003C\u002Fi\u003E大カテゴリの管理\u003C\u002Fmd-button\u003E";;return pug_html;};
module.exports = template;